import { useEffect, useState } from 'react';
import { api, type Rule } from '../api.js';

/** The rules live in the database, not in the code — carriers map differently
 *  from one country to the next, and the client must be able to calibrate them
 *  without calling us. */
export default function Rules() {
  const [rules, setRules] = useState<Rule[]>([]);
  const [err, setErr] = useState('');

  useEffect(() => { api.rules().then(setRules).catch((e) => setErr(e.message)); }, []);

  return (
    <>
      <h1>Classification rules</h1>
      <p className="subtitle">
        The first matching rule wins. <code>*</code> means "any value".
      </p>
      {err && <div className="err">{err}</div>}
      <div className="table-wrap">
        <table>
          <thead><tr>
            <th>Prio</th><th>DIALSTATUS</th><th>SIP</th><th>Q.850</th>
            <th>Audio</th><th>Verdict</th><th>Note</th>
          </tr></thead>
          <tbody>
            {rules.map((r) => (
              <tr key={r.id}>
                <td className="num">{r.priority}</td>
                <td className="num">{r.matchDialstatus ?? <span className="muted">*</span>}</td>
                <td className="num">{r.matchSip ?? <span className="muted">*</span>}</td>
                <td className="num">{r.matchQ850 ?? <span className="muted">*</span>}</td>
                <td className="num">{r.matchAudioPattern ?? <span className="muted">*</span>}</td>
                <td><span className={`tag ${r.disposition}`}>{r.disposition}</span></td>
                <td className="wrap">{r.note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
